import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-division-error-page',
  templateUrl: './no-division-error-page.component.html',
  styleUrls: ['./no-division-error-page.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NoDivisionErrorPageComponent { }
